/**
 * @generated SignedSource<<bff732810d1282faa4e73f7e538b768c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
import { FragmentRefs } from "relay-runtime";
export type StreamLink_stream$data = {
  readonly displayName: string;
  readonly hasExternalUsers: boolean;
  readonly id: string;
  readonly isExternal: boolean;
  readonly latestNote: {
    readonly event: {
      readonly guid: string;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"RecordIcon_event">;
    } | null;
    readonly eventEnd: string | null;
    readonly eventStart: string | null;
    readonly finished: boolean;
    readonly id: string;
  } | null;
  readonly latestNoteEditedAt: string | null;
  readonly linkedEvent: {
    readonly finalOccurrence: string | null;
    readonly guid: string;
    readonly id: string;
    readonly nextOccurrence: {
      readonly end: string | null;
      readonly start: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"RecordIcon_event">;
    } | null;
  } | null;
  readonly otherUser: {
    readonly " $fragmentSpreads": FragmentRefs<"OneOnOneLink_user">;
  } | null;
  readonly publicLink: {
    readonly enabled: boolean;
  } | null;
  readonly type: NoteStreamType;
  readonly url: string | null;
  readonly userCount: number;
  readonly viewerLastSeenAt: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"GroupsMenu_stream">;
  readonly " $fragmentType": "StreamLink_stream";
};
export type StreamLink_stream$key = {
  readonly " $data"?: StreamLink_stream$data;
  readonly " $fragmentSpreads": FragmentRefs<"StreamLink_stream">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guid",
  "storageKey": null
},
v2 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "RecordIcon_event"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StreamLink_stream",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerLastSeenAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "latestNoteEditedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExternalUsers",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GroupsMenu_stream"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "otherUser",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "OneOnOneLink_user"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "linkedEvent",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "nextOccurrence",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "start",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "end",
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "finalOccurrence",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Note",
      "kind": "LinkedField",
      "name": "latestNote",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventStart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventEnd",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "finished",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "event",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStreamPublicLink",
      "kind": "LinkedField",
      "name": "publicLink",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};
})();

(node as any).hash = "660cbdb8714c0139579bd86ca6640b14";

export default node;
